import { token } from '@atlaskit/tokens';

// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
const extraSelectProps = {
	menuPortalTarget: document.body,
	styles: {
		menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
		container: (base: any) => ({
			...base,
			flex: `1 1 auto`,
			marginLeft: `${token('space.negative.075', '-6px')}`,
		}),
	},
};

export { extraSelectProps };
